/* SAOTO — Sticky Add to Cart premium.
   Affiche la barre uniquement quand aucun bouton "Ajouter au panier" réel
   n'est visible à l'écran, et seulement après un peu de scroll. */
(function () {
  function initStickyAtc() {
    var bar = document.querySelector('[data-saoto-sticky-atc]');
    if (!bar) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) bar.classList.add('saoto-sticky-atc--no-anim');

    var triggers = Array.prototype.slice.call(
      document.querySelectorAll('.product-form__submit, footer, #shopify-section-template--32447186567517__saoto_reviews_carousel, #shopify-section-template--32447186567517__image_and_text_scrolling_pFw6Uj, #shopify-section-template--32447186567517__videosavis_NUHrpX')
    ).filter(function (el) {
      return !bar.contains(el);
    });

    var anyTriggerVisible = triggers.length > 0;
    var scrolledEnough = false;
    var ticking = false;

    function isInViewport(el) {
      var rect = el.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight;
    }

    function refreshVisibility() {
      anyTriggerVisible = triggers.some(isInViewport);
      update();
    }

    function update() {
      var shouldShow = scrolledEnough && !anyTriggerVisible;
      bar.classList.toggle('visible', shouldShow);
    }

    if (triggers.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(refreshVisibility, { threshold: 0 });
      triggers.forEach(function (el) {
        observer.observe(el);
      });
    }

    var minScroll = Math.round(window.innerHeight * 0.6);

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        scrolledEnough = window.scrollY > minScroll;
        update();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
})();
